// src/virtual-dom.ts
var NODE_TYPE_EMPTY = "empty";
var NODE_TYPE_TAG = "tag";
var NODE_TYPE_TEXT = "text";
var NODE_TYPE_CUSTOM = "custom";
var NODE_TYPE_FRAGMENT = "fragment";
function isVNode(v) {
  return (
    v != null &&
    typeof v === "object" &&
    "type" in v &&
    (v.type === NODE_TYPE_EMPTY ||
      v.type === NODE_TYPE_TEXT ||
      v.type === NODE_TYPE_TAG ||
      v.type === NODE_TYPE_CUSTOM ||
      v.type === NODE_TYPE_FRAGMENT)
  );
}
function isReservedTagProp(key) {
  return key === "ref" || key === "children";
}
var EMPTY_NODE = {
  type: NODE_TYPE_EMPTY,
};
function getVNodeKey(node) {
  if (
    node.type === NODE_TYPE_TAG ||
    node.type === NODE_TYPE_CUSTOM ||
    node.type === NODE_TYPE_FRAGMENT
  ) {
    return node.key;
  }
  return;
}
function getBNodeKey(node) {
  if (
    node.type === NODE_TYPE_TAG ||
    node.type === NODE_TYPE_CUSTOM ||
    node.type === NODE_TYPE_FRAGMENT
  ) {
    return node.vnode.key;
  }
  return;
}
function getBNodeSlot(node) {
  if (node.type === NODE_TYPE_EMPTY) {
    return null;
  }
  if (node.type === NODE_TYPE_TAG || node.type === NODE_TYPE_TEXT) {
    return node.hnode;
  }
  return node.slot;
}
function getBNodeParent(node) {
  if (node.type === NODE_TYPE_CUSTOM || node.type === NODE_TYPE_FRAGMENT) {
    return node.parent;
  }
  return null;
}
function setBNodeParent(node, parent) {
  if (node.type === NODE_TYPE_CUSTOM || node.type === NODE_TYPE_FRAGMENT) {
    node.parent = parent;
  }
}
function createVNode(tag, props, key) {
  if (typeof tag === "string") {
    return {
      type: NODE_TYPE_TAG,
      name: tag,
      key,
      props,
    };
  }
  if (typeof tag === "function") {
    return {
      type: NODE_TYPE_CUSTOM,
      render: tag,
      key,
      props,
    };
  }
  return tag;
}
function createElement(tag, { key, ...props }, ...children) {
  if (children.length > 0) {
    props.children = children.length === 1 ? children[0] : children;
  }
  return createVNode(tag, props, key);
}
function Fragment(props) {
  return normalizeComponentChildren(props.children);
}
function normalizeComponentChildren(children) {
  if (Array.isArray(children)) {
    return {
      type: NODE_TYPE_FRAGMENT,
      children: children.map((c) => normalizeComponentChildren(c)),
    };
  }
  return normalizeComponentChild(children);
}
function normalizeComponentChild(child) {
  if (
    child === null ||
    typeof child === "undefined" ||
    typeof child === "boolean"
  ) {
    return EMPTY_NODE;
  }
  if (typeof child === "string" || typeof child === "number") {
    return {
      type: NODE_TYPE_TEXT,
      data: String(child),
    };
  }
  return child;
}

export {
  NODE_TYPE_EMPTY,
  NODE_TYPE_TAG,
  NODE_TYPE_TEXT,
  NODE_TYPE_CUSTOM,
  NODE_TYPE_FRAGMENT,
  isVNode,
  isReservedTagProp,
  EMPTY_NODE,
  getVNodeKey,
  getBNodeKey,
  getBNodeSlot,
  getBNodeParent,
  setBNodeParent,
  createVNode,
  createElement,
  Fragment,
  normalizeComponentChildren,
};
